/* eslint-disable global-require */
module.exports = ['components.lotslists.noaccess.m1', 'components.lotslists.noaccess.m3', 'components.lotslists.landingpage.m12', 'components.lotslists.create.success.m3', 'components.lotslists.create.m9'];
